import { Tab, Tabs, Typography } from "@mui/material";
import React from "react";

const CustomTabs = ({ tabsData, value, onChange }) => {
  return (
    <Tabs value={value} onChange={(event, newValue) => onChange(newValue)}>
      {tabsData?.map((tab) => (
        <Tab
          key={tab.id}
          value={tab.id}
          label={
            <Typography
              variant="body2"
              fontWeight={value === tab.id ? 600 : 400}
            >
              {tab.label}
            </Typography>
          }
        />
      ))}
    </Tabs>
  );
};

export default CustomTabs;